<div class="p-8 w-[228px]">
  <div class="flex gap-6 justify-between pb-8">
    <div class="font-medium">{{ date() | dateFormat : 'date' }}</div>
    <app-close-component (click)="handleClosePopover()" />
  </div>

  <stch-big-events-preview-list [events]="events()" (eventClicked)="eventClicked.emit($event)" (eventDblClicked)="eventDblClicked.emit($event)" />
</div>
